'use strict';

/**
 * will grab a pdf from an url and render it on a canvas element
 * data-sw-pdf-url='<url to the pdf>'
 * data-sw-pdf-target='<pass the canvas target where to render the pdf, if none give will try to use the current element'
 */
/* jshint ignore:start */
var $ = require('js/sw-jquery/sw-jquery');
var swUtils = require('js/lib/sw-utils');
var pdfjsLib = require('pdfjs-dist/legacy/build/pdf');
var pdfWorkerLocation = '../rrstatic/javascript/node_modules/pdfjs-dist/legacy/build/pdf.worker.js';

var ATTRS = {
    ROOT: 'data-sw-pdf',
    URL: 'data-sw-pdf-url',
    target: 'data-sw-pdf-target'
};


module.exports = function($fragment) {
    $fragment.swFindWithSelf(swUtils.makeAttributeValueSelector(ATTRS.ROOT)).each(function() {
        var $el = $(this);
        var url = $el.swDataAttr(ATTRS.URL);
        // The worker to be able to process pdf async
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerLocation;

        // Asynchronous download of PDF
        var loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(function(pdf) {
            $el.empty();
            for (var pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
                pdf.getPage(pageNumber).then( function( page) {
                    var scale = 1;
                    var viewport = page.getViewport({scale: scale});
                    // Prepare canvas using PDF page dimensions
                    var canvas = document.createElement( 'canvas');
                    canvas.style.display = 'block';
                    var context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    $el.append(canvas);

                    // Render PDF page into canvas context
                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function () {
                    });
                });
            }
        }, function (reason) {
            // PDF loading error
            window.console.error(reason);
        });
    });
};
/* jshint ignore:end */
